import typeChecker from '../typeChecker'

const getEllipsis = (str: string, size: number) => {
  if (!str || !typeChecker.isString(str) || (!typeChecker.isNumber(size) || size < 0)) return str

  if (size < str.length) return `${str.slice(0, size)}...`
  return str
}

export const StringUtils = {
  getEllipsis,
}
